// Regular expressions helper

export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const splitUppercase = /(?=[A-Z])/;

export const phoneNumberRegex = /^[0-9 ().+-]*$/;

export const integerRegex = /^-?\d+$/;

export const floatRegex = /^-?\d+(\.\d+)?$/;

export const engineSizeRegex = /^[A-Za-z0-9. ]+$/;
